import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentCompany: null,
    listing: {
        page: 1,
        resultLength: 25,
    },
};

const companySlice = createSlice({
    name: "company",
    initialState,
    reducers: {
        currentCompany: (state, action) => {
            state.currentCompany = action.payload;
        },
        setPage: (state, action) => {
            state.listing.page = action.payload;
        },
        setResultLength: (state, action) => {
            state.listing.resultLength = action.payload;
        },
    },
});

export const { currentCompany, setPage, setResultLength } =
    companySlice.actions;
export default companySlice.reducer;
